'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var BorderlessButton = require('../BorderlessButton/BorderlessButton.js');

var PillButton = function (props) {
    var title = props.title, onClick = props.onClick, _a = props["data-testid"], dataTestId = _a === void 0 ? 'status-button' : _a;
    return (React__default.createElement(BorderlessButton, { style: { borderRadius: '15px', backgroundColor: '#E7EEF4' }, title: title, onClick: onClick, "data-testid": dataTestId }));
};

module.exports = PillButton;
